import { render, staticRenderFns } from "./WardMap.vue?vue&type=template&id=a1119ebc&scoped=true&"
import script from "./WardMap.vue?vue&type=script&lang=js&"
export * from "./WardMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1119ebc",
  null
  
)

export default component.exports